module.exports = __webpack_public_path__ + "img/course_bg8.fcdaec69.png";